import Grid from "@material-ui/core/Grid";
import { useSearchParamsToReducer } from "../hooks/useSearchParamsToReducer";
import { EndFilter, SearchFilter, StartFilter } from "./";
import type { KeyboardEventHandler } from "react";
import { StatusFilter } from "./StatusFilter";

type Props = {
	onKeyDown: KeyboardEventHandler<HTMLDivElement> | undefined;
};

export const Filters = ({ onKeyDown }: Props) => {
	useSearchParamsToReducer();

	return (
		<Grid
			container
			item
			md={12}
			xs={12}
			justifyContent="center"
			alignItems="center"
		>
			<Grid
				item
				lg={3}
				md={6}
				xs={6}
				style={{ margin: "0 auto 8px", padding: "0 10px" }}
			>
				<StartFilter />
			</Grid>
			<Grid
				item
				lg={3}
				md={6}
				xs={6}
				style={{ margin: "0 auto 8px", padding: "0 10px" }}
			>
				<EndFilter />
			</Grid>
			<Grid
				item
				lg={3}
				md={6}
				xs={6}
				style={{ height: "47px", padding: "0 10px", marginBottom: 5 }}
			>
				<SearchFilter onKeyDown={onKeyDown} />
			</Grid>
			<Grid
				item
				lg={3}
				md={6}
				xs={6}
				style={{ padding: "0 10px", marginBottom: 10 }}
			>
				<StatusFilter />
			</Grid>
		</Grid>
	);
};
